import * as core from '../../../../../../../core'

import { query } from './subrecipient-details-info.query'

export const RESOURCE = {
  payload: {
    alias: 'sr.subrecipient-details.widgets.info',
    description: 'Subrecipient Details',
    name: 'Subrecipient Details',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
